import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaUserPlus } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import api from "../services/api";

const Signup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert(t('auth.passwordMismatch'));
      return;
    }

    try {
      await api.post("/api/auth/register", {
        firstname: formData.firstname,
        lastname: formData.lastname,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
      });
      alert(t('auth.signupSuccess'));
      navigate('/signin');
    } catch (err) {
      const m = err?.response?.data?.message || t('auth.signupError');
      alert(m);
    }
  };

  return (
    <div className="bg-[#f7f9fc] min-h-screen flex flex-col">
      <Header />
      <div className="flex-grow flex items-center justify-center py-10">
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-xl p-8 rounded-2xl w-full max-w-xl mx-4"
        >
          <div className="flex justify-center mb-4">
            <div className="bg-gradient-to-r from-purple-500 to-blue-500 p-4 rounded-full">
              <FaUserPlus className="text-white text-2xl" />
            </div>
          </div>
          <h2 className="text-3xl font-bold text-center text-purple-600 mb-2">
            {t('auth.signupTitle')}
          </h2>
          <p className="text-center text-gray-600 mb-6">
            {t('auth.signupSubtitle')}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              name="firstname"
              placeholder={t('auth.firstName')}
              className="border rounded-md px-4 py-3 w-full"
              required
              onChange={handleChange}
            />
            <input
              name="lastname"
              placeholder={t('auth.lastName')}
              className="border rounded-md px-4 py-3 w-full"
              required
              onChange={handleChange}
            />
          </div>

          <input
            name="email"
            type="email"
            placeholder={t('auth.email')}
            className="mt-4 border rounded-md px-4 py-3 w-full"
            required
            onChange={handleChange}
          />
          <input
            name="phone"
            placeholder={t('auth.phone')}
            className="mt-4 border rounded-md px-4 py-3 w-full"
            onChange={handleChange}
          />
          <input
            name="password"
            type="password"
            placeholder={t('auth.passwordHint')}
            className="mt-4 border rounded-md px-4 py-3 w-full"
            required
            minLength={6}
            onChange={handleChange}
          />
          <input
            name="confirmPassword"
            type="password"
            placeholder={t('auth.confirmPassword')}
            className="mt-4 border rounded-md px-4 py-3 w-full"
            required
            onChange={handleChange}
          />

          <button
            type="submit"
            className="bg-gradient-to-r from-blue-600 to-purple-600 text-white w-full mt-6 py-3 rounded-xl font-semibold shadow-md hover:opacity-90 transition"
          >
            {t('auth.signupButton')}
          </button>

          <div className="text-center mt-4 text-sm">
            {t('auth.haveAccount')}{' '}
            <a href="/signin" className="text-blue-600 font-semibold">
              {t('auth.signinButton')}
            </a>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default Signup;

